// nextjs, react
import { useRouter } from 'next/router'
import Head from 'next/head'
import { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectSite, addSearchGame } from '../../store/slice/site'
import { Box, Flex, Center } from '@chakra-ui/react'
// Components
import Menu from '../../components/Menu'
import Card from '../../components/Card'
import { motion, AnimatePresence } from "framer-motion";
// React Query
import { useGameData } from '../../hooks/useGameData'
// Components
import Preloader from '../../components/Preloader'

const variants = {
  fadeIn: {
    y: 100,
    opacity: 0,
    transition: {
      duration: .5,
      ease: "easeInOut"
    }
  },
  inactive: {
    opacity: 1,
    y: 0,
    transition: {
      duration: .5,
      ease: "easeInOut"
    }
  },
  fadeOut: {
    opacity: 0,
    y: -100,
    transition: {
      duration: .5,
      ease: "easeInOut"
    }
  }
};

const Vendor = () => {
  const state = useSelector(selectSite)
  const router = useRouter()
  const dispatch = useDispatch()
  const [games, setGames] = useState([]) // 遊戲列表
  // const [hasNextPage, setHasNextPage] = useState(true) // 是否有下一頁
  /*--- react query：取得遊戲清單 ---*/
  const {
    data: gameListData,
    refetch: gameListRefetch,
    fetchNextPage: gameListFetchNextPage,
    isFetchingNextPage: gameListIsFetchingNextPage,
    hasNextPage: gameListHasNextPage,
    isFetching: isFetching,
  } = useGameData(state.searchGame)

  // 元件：Loading
  const Loading = () => {
    return (
      <Center flexDir='column'>
        <Preloader />
      </Center>
    )
  }

  return (
    <Flex
      px={{ base: '1rem', md: '1.5rem', lg: '2.5rem', xl: '6.5rem' }}
      justify={{ base: 'center', lg: 'space-between' }}
      direction={{ base: 'column', lg: 'row' }}
      gap='10'
    >
      <Head>
        <title>Hello Demo | Golden F</title>
        <meta name="description" content="Hello Demo 试玩站 | Golden F" />
        <meta name="robots" content="noindex"></meta>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <Box flex='1'>
        <Menu
          searchGame={gameListRefetch}
        />
      </Box>

      <Box
        flex='5'
        mt={{ base: '1rem', lg: '5rem' }}
        overflow='hidden'>
        <AnimatePresence
          initial={false}
          mode='wait'
        >
          <motion.div
            key={router.asPath}
            variants={variants}
            initial="fadeIn"
            animate="inactive"
            exit="fadeOut"
          >
            {isFetching && (
              <Loading />
            )}

            <Card
              data={gameListData}
              hasNextPage={gameListHasNextPage}
              isFetchingNextPage={gameListIsFetchingNextPage}
              isFetching={isFetching}
              gameListFetchNextPage={gameListFetchNextPage}
            />
          </motion.div>
        </AnimatePresence>
      </Box>

    </Flex >
  )
}

export default Vendor;